/**
 * ehr#682 (PROGRESS-NOTE V141 V83.4): "Take it back". After Request changes the reviewer gets a
 * few minutes (the API's TAKE_BACK_MS) to pull the note back into review, until its author starts
 * on it; the API says until when (takeBackUntil) and checks it again on the click.
 */

/** Milliseconds left before `until` (an ISO time), never below 0; 0 for none or a bad time. */
export function takeBackLeft(until: string | null | undefined, now: number): number {
  if (!until) return 0;
  const t = Date.parse(until);
  return Number.isFinite(t) ? Math.max(0, t - now) : 0;
}

/** The countdown as V141 shows it: minutes and seconds, "4:59", "0:07". */
export function fmtLeft(ms: number): string {
  const s = Math.max(0, Math.ceil(ms / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}

/** V141's footer line beside the button. */
export function takeBackLine(authorName: string): string {
  const first = authorName.trim().split(/\s+/)[0] || 'the clinician';
  return `Sent to ${first}. You have a few minutes to take it back if you need to make more changes.`;
}
